import MKEvent from '../utils/MKEvent';

export default class SpinButton {
	constructor(scene, spriteNormal, spriteHover, isSwitch) {
		this.spriteNormal = spriteNormal;
		this.spriteHover = spriteHover;
		this.scene = scene;
		this.slotControls = scene.slotControls;
		this.clickEvent = new MKEvent();
		this.longPressClickEvent = new MKEvent();
		this.pointerDownEvent = new MKEvent();
		this.longPointerDownEvent = new MKEvent();
		this.isSwitch = isSwitch;
	}

	create(offsetX, offsetY, originX, originY) {
		this.offsetX = offsetX;
		this.offsetY = offsetY;
		this.originX = originX;
		this.originY = originY;

		this.posX = this.scene.centerX + this.offsetX;
		this.posY = this.scene.centerY + this.offsetY;

		this.button = this.scene.add.sprite(this.posX, this.posY, this.spriteNormal).setOrigin(originX, originY);
		this.button.on('pointerdown', this.pointerDown, this);
		this.button.on('pointerup', this.pointerUp, this);
		this.button.on('pointerover', this.pointerOver, this);
		this.button.on('pointerout', this.pointerOut, this);
		this.button.setInteractive();
		this.interactable = true;
		this.pressed = false;
		this.pDown = false;
		this.up = true;
		//this.downTime = 0;
		this.longPressTime = 2000; // miliseconds
		this.longPress = false;
		this.timeoutID = -1;
	}

	pointerUp() {
		if (this.timeoutID !== -1) clearTimeout(this.timeoutID); // remove timer if exist
		this.up = true;

		if (!this.pDown) return;
		this.pDown = false; // reset pdown

		if (!this.interactable) return;
		if (!this.isSwitch) this.pressed = false;

		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
		if (this.longPress) {
			this.longPress = false;
			this.longPressClickEvent.invoke();
		} else {
			this.clickEvent.invoke();
		}
	}

	pointerDown() {
		if (this.timeoutID !== -1) clearTimeout(this.timeoutID); // remove timer
		this.longPress = false;
		this.up = false;
		this.pDown = true;
		if (!this.interactable) return;
		if (this.isSwitch) this.pressed = !this.pressed;
		this.button.setTexture(this.spriteHover); //         console.log('button down', arguments);
		this.pointerDownEvent.invoke();

		this.timeoutID = setTimeout(() => {
			this.longPress = true;
			this.longPointerDownEvent.invoke();
		}, this.longPressTime);
	}

	pointerOver() {
		if (!this.interactable) return;
		// this.button.setTexture(this.spriteHover);
	}

	pointerOut() {
		if (this.timeoutID !== -1) clearTimeout(this.timeoutID); // remove timer
		if (!this.interactable) return;
		// this.button.setTexture(this.spriteNormal);
	}

	setInteractable(interactable) {
		this.interactable = interactable;
	}

	addClickEvent(action, context) {
		this.clickEvent.add(action, context);
	}

	release() {
		this.pressed = false;
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
	}

	setPressed() {
		this.pressed = true;
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
	}

	setDepth(depth) {
		this.button.depth = depth;
	}

	setSpinModeText(auto) {}
}
